export default "__VITE_ASSET__qqhaofLx__"